/**
 * Generate and download sample CSV
 * @param {Array} columns [{ key: 'name', label: 'Country Name' }]
 * @param {String} fileName
 */
export const downloadSampleCSV = (columns, fileName = "sample.csv") => {
  const headers = columns.map(col => col.key);

  const sampleRow = columns.map(col => col.sample || "");

  const csvContent =
    headers.join(",") + "\n" + sampleRow.join(",");

  const blob = new Blob([csvContent], {
    type: "text/csv;charset=utf-8;"
  });

  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");

  link.href = url;
  link.setAttribute("download", fileName);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};


/**
 * Parse CSV file and return JSON
 * Ignores header automatically
 * @param {File} file
 * @param {Array} columns [{ key: 'name' }]
 */
export const parseCSV = (file, columns) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = ({ target }) => {
      try {
        const rows = target.result
          .split("\n")
          .map(r => r.trim())
          .filter(Boolean);

        // Remove header row
        const dataRows = rows.slice(1);

        const result = dataRows.map(row => {
          const values = row.split(",");
          const obj = {};

          columns.forEach((col, index) => {
            obj[col.key] = values[index]?.trim();
          });

          return obj;
        }).filter(row =>
          Object.values(row).some(val => val)
        );

        resolve(result);
      } catch (err) {
        reject("Invalid CSV format");
      }
    };

    reader.onerror = () => reject("File read error");
    reader.readAsText(file);
  });
};
